export default __webpack_public_path__ + "static/media/stufflayout-bag.d4859ecb.png";